import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../models/user';
import { StoredUserInfo } from '../models/storeduserinfo';

export interface UserContactDetailsRequest {
  email: string;
  phoneNumber: string;
}

export interface UserProfileUpdateRequest {
  userId: number;
  /*
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  preferredName: string;
  */
  address1: string;
  address2: string;
  address3: string;
  city: string;
  state: string;
  zipCode: string;
  preferredContact: string;
  preferredLanguage: string;
  modifiedBy: number;
}

@Injectable({
  providedIn: 'root'
})

export class UserService {
  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);
  private dashApiUrl = environment.dashApiUrl;

  getUserInfo(request: UserContactDetailsRequest): Observable<User> {
    return this.http.post<User>(
      `${this.dashApiUrl}/api/user/getUser`,
      request,
      { withCredentials: true }
    );
  }

  updateUserProfile(request: UserProfileUpdateRequest): Observable<User> {
  return this.http.post<User>(`${this.dashApiUrl}/api/user/UpdateUserProfile`, request);
}

  //TEMP: store basic user information within local storage
  //TODO: Save JWT
  saveUserInfo(userInfo: StoredUserInfo): void {
    //if (!isPlatformBrowser(this.platformId)) return;
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }

  getUserInfoFromStorage(): StoredUserInfo | null {
    if (!isPlatformBrowser(this.platformId)) return null;
    const stored = localStorage.getItem('userInfo');
    return stored ? JSON.parse(stored) : null;
  }

  clearUserInfo(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    localStorage.removeItem('userInfo');
  }
}